import './../App.css';
import '../css/pages/homepage.css';
import { useEffect, useState, useRef } from 'react';
import bg from "../img/Chantiers/Rénovation_Complète/Chantier_Jean_de_La_Fontaine/1_après.jpg";
import bg1 from "../img/section-bg-1.jpg";
import bg3 from '../img/section-bg-2.png';
import bg2 from '../img/section-bg-5.jpg';
import Axios from 'axios'
import { apiUrl } from '../constants/Constants';
import { Link, NavLink } from 'react-router-dom';
import LoadingBar from "react-top-loading-bar";
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';

import { CompetenceItemsGrid, FooterComponent, FooterMainComponent, NosCompetenceContents } from '../components/MainComponents';

function Index() {
    const backgroundStyle = {
        backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)),url(${bg})`,
        height: '100vh',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',

    };

    const backgroundStyle1 = {
        backgroundImage: `url(${bg1})`,
        height: '100vh',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    const backgroundStyle2 = {
        backgroundImage: `url(${bg2})`,
        height: '50vh',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    const backgroundStyle3 = {
        backgroundImage: `url(${bg3})`,
        backgroundRepeat: 'no-repeat',
    };




    const navigation = useNavigate();

    const ref = useRef(null);


    const [chantiersList, setChantiersList] = useState([]);
    const [chantiersImagesList, setChantiersImagesList] = useState([]);
    const [allImagesList, setAllImagesList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [projets, setProjets] = useState("");
    const [clients, setClients] = useState("");
    const [nbpieces, setNbpieces] = useState("");

    const [mobilenav, setMobilenav] = useState(false)

    const [carousel, setCarousel] = useState(false);
    const [carouselindex, setCarouselIndex] = useState(-1);
    const [carouselindex2, setCarouselIndex2] = useState(-1);
    const [carouselindex3, setCarouselIndex3] = useState(-1);
    const [carouseltitle, setCarouselTitle] = useState("");
    const [carouseltype, setCarouselType] = useState("");
    const [carouseldesc, setCarouselDesc] = useState("");
    const [carouseladdresse, setCarouselAddresse] = useState("");
    const [carouselpic, setCarouselPic] = useState("");
    const [carouselimageindex, setCarouselImageIndex] = useState(0)
    const [carouselmobile, setCarouselMobile] = useState(false)
    const [selected, setSelected] = useState("")

    const [smallcarouselimages, setSmallCarouselImages] = useState([]);

    const [isFullScreen, setIsFullScreen] = useState(false);
    const imageRef = useRef(null);

    const handleFullScreen = () => {
        if (isFullScreen) {
            document.exitFullscreen();
        } else {
            imageRef.current.requestFullscreen();
        }
        setIsFullScreen(!isFullScreen);
    };


    const getChantiersApi = () => {
        setIsLoading(true)
        document.body.style.overflow = "hidden"
        setChantiersList([])
        Axios.get(apiUrl + 'getChantier.php')
            .then((responseJson) => {
                if (responseJson.data === '0 results') {
                    setChantiersList([])
                }
                else {
                    filterEmptyImages(responseJson.data)
                    global.chlist = responseJson.data;
                }
            }
            );
    }

    const filterEmptyImages = (data) => {
        const filterEmpty = data.filter(item => {
            if (!item.ch_onlyMap.includes("Non")) {
                return false;
            }
            return true
        }
        )
        setChantiersList(filterEmpty);
    }


    const getAllImagesApi = () => {
        setAllImagesList([])
        Axios.get(apiUrl + 'selectAllImages.php')
            .then((responseJson) => {
                if (responseJson.data === '0 results') {
                    setAllImagesList([])
                    setTimeout(() => {
                        setIsLoading(false)
                        document.body.style.overflow = "visible"
                    }, 3000);
                    ref.current.complete();
                }
                else {
                    setAllImagesList(responseJson.data)
                    global.listAllImages = responseJson.data; setTimeout(() => {
                        setIsLoading(false)
                        document.body.style.overflow = "visible"
                    }, 3000);
                    ref.current.complete();
                }
            }
            );
    }


    const getCarouselFilteredImages = (ch_id) => {
        const filterCarouselList = allImagesList.filter((auto) => auto.ch_id == ch_id)
        setChantiersImagesList(filterCarouselList)
        setSmallCarouselImages(filterCarouselList)
        setSelected(filterCarouselList[0]?.ch_img)
    }

    const getStatsApi = () => {
        Axios.get(apiUrl + 'getStats.php')
            .then((responseJson) => {
                if (responseJson.data === '0 results') {
                    console.log("vide")
                }
                else {
                    setProjets(responseJson.data[0].projets)
                    setClients(responseJson.data[0].clients)
                    setNbpieces(responseJson.data[0].nb_pieces)
                }
            }
            );
    }

    const handleLoadSomething = () => {
        ref.current.continuousStart();
    };

    function topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    const callApi = () => {
        getChantiersApi()
        getStatsApi()
        getAllImagesApi()
    }

    const scrollToCarousel = (id, index, ch_nom, ch_type, ch_desc, ch_addresse, pic) => {

        setCarouselImageIndex(0)

        if (carousel == false) {
            getCarouselFilteredImages(id);
            //index <= 2 ? setCarouselIndex(0) : setCarouselIndex(3);
            setCarouselIndex(index - index % 3)
            setCarousel(true);
            //index <= 1 ? setCarouselIndex2(0) : index <= 3 ? setCarouselIndex2(2) : setCarouselIndex2(4);
            setCarouselIndex2(index - index % 2)
            setCarouselIndex3(index)
            setCarouselTitle(ch_nom);
            setCarouselDesc(ch_desc);
            setCarouselAddresse(ch_addresse);
            setCarouselType(ch_type);
            setCarouselPic(pic);
            setTimeout(function () {
                const topOfElement = document.querySelector('#my-carousel').offsetTop - 70;
                window.scroll({ top: topOfElement, behavior: "smooth" });
            }, 200);
            
        setIsLoading(true)
        }
        else {

            if (index == carouselindex3) {
                setCarousel(false);
                setCarouselIndex(-1)
                setCarouselIndex2(-1)
                setCarouselIndex3(-1)
                setCarouselTitle("");
                setCarouselType("");
                setCarouselDesc("");
                setCarouselAddresse("");
                setCarouselPic("");
                setSelected("")

            } else {
                getCarouselFilteredImages(id);
                //index <= 2 ? setCarouselIndex(0) : setCarouselIndex(3);
                setCarouselIndex(index - index % 3)
                setCarousel(true);
                //index <= 1 ? setCarouselIndex2(0) : index <= 3 ? setCarouselIndex2(2) : setCarouselIndex2(4);
                setCarouselIndex2(index - index % 2)
                setCarouselIndex3(index)
                setCarouselTitle(ch_nom);
                setCarouselDesc(ch_desc);
                setCarouselAddresse(ch_addresse);
                setCarouselType(ch_type);
                setCarouselPic(pic);
                setTimeout(function () {
                    const topOfElement = document.querySelector('#my-carousel').offsetTop - 70;
                    window.scroll({ top: topOfElement, behavior: "smooth" });
                }, 200);
                
        setIsLoading(true)
            }
        }
    }

    const getpicIndex = (pic) => {

        const myindex = chantiersImagesList.findIndex(obj => obj.ch_img === pic);
        setSelected(pic);
        increaseCarousel(myindex);

    }

    useEffect(() => {
        handleLoadSomething()
        callApi()
        global.globalType = "all";
    }, [])

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 575) {
                setCarouselMobile(false);
            } else {
                setCarouselMobile(true)
            }
        }

        handleResize();
        window.addEventListener("resize", handleResize);

    }, [window.innerWidth]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 992) {
                setMobilenav(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);

    }, [window.innerWidth]);



    const increaseCarousel = (inc) => {
        if (inc == -1) {
            if (carouselimageindex == chantiersImagesList.length - 1) {
                setCarouselImageIndex(0)
                if (smallcarouselimages.findIndex(obj => obj.ch_img === chantiersImagesList[carouselimageindex].ch_img) == 3) {
                    increaseSmallCarousel()
                }
                setSelected(chantiersImagesList[0].ch_img)
            }
            else {
                setCarouselImageIndex(prev => prev + 1)
                if (smallcarouselimages.findIndex(obj => obj.ch_img === chantiersImagesList[carouselimageindex].ch_img) == 3) {
                    increaseSmallCarousel()
                }
                setSelected(chantiersImagesList[carouselimageindex + 1].ch_img)
            }
        }
        else {
            setCarouselImageIndex(inc)
        }
    }

    const decreaseCarousel = (dec) => {
        if (dec == -1) {
            if (carouselimageindex == 0) {
                setCarouselImageIndex(chantiersImagesList.length - 1)
                if (smallcarouselimages.findIndex(obj => obj.ch_img === chantiersImagesList[carouselimageindex].ch_img) == 0) {
                    decreaseSmallCarousel()
                }
                setSelected(chantiersImagesList[chantiersImagesList.length - 1].ch_img)
            }
            else {
                setCarouselImageIndex(prev => prev - 1)
                if (smallcarouselimages.findIndex(obj => obj.ch_img === chantiersImagesList[carouselimageindex].ch_img) == 0) {
                    decreaseSmallCarousel()
                }
                setSelected(chantiersImagesList[carouselimageindex - 1].ch_img)
            }
        }
    }

    const increaseSmallCarousel = () => {

        const newItems = [...smallcarouselimages];
        newItems.push(newItems.shift());
        setSmallCarouselImages(newItems);
    }

    const decreaseSmallCarousel = () => {

        const newItems = [...smallcarouselimages];
        newItems.unshift(newItems.pop());
        setSmallCarouselImages(newItems);
    }

    const getMarginTop = (i) => {
        if (carouselmobile && (i == 0 || i == 2 || i == 4)) {
            console.log("i and carousel mobiel", i, carouselmobile)
            return "my-margin-top"
        }
        else if (!carouselmobile && (i == 0 || i == 3)) {
            return "my-margin-top"
        }

        return ""
    }

    return (
        <div id='mainCont'>
            {isLoading && <div class="my-loader-container"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div><div></div><div></div></div></div>}
            <LoadingBar color="#cf152d" ref={ref} />
            <Helmet>
                <title>Décohome75</title>
                <meta name="description" content="Décohome75 est une entreprise de rénovation intégrale pour maison basée à Paris, France, spécialisée dans les rénovations de salle de bain, cuisine, murs et sols. Nous proposons des services de maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie et carrelage." />
                <meta name="keywords" content="rénovation, maison, rénovation intégrale, rénovation complète, salle de bain, cuisine, murs et sols, maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie, carrelage" />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <div id="top">

                {/* Banner */}

                <div class="home-banner-area" style={backgroundStyle}>
                    <div>
                        <img src="assets/images/logo-white-2.png" class="" width="300" height="auto" alt="" />
                        <h2 class=" home-banner-title" >
                            Rénovons Votre Quotidien
                        </h2>
                        <div class="local-scroll home-red-button-container">

                            <div onClick={() => { isLoading ? console.log("") : document.getElementById('about').scrollIntoView({ behavior: 'smooth', }) }}
                                class="home-red-button">
                                Découvrir la rénovation
                            </div>
                        </div>
                    </div>

                </div>

                {/* navbar */}


                <div class="home-navbar">
                    <div class="container mynavbar-container" >
                        <div class="">
                            <Link
                                to="/"
                                className="my-navbar-logo"
                                onClick={() => topFunction()}
                            ><img src="../assets/images/logo-dark.png" alt="" /></Link>
                        </div>
                        <div className='mynvabar-links'>
                            <NavLink
                                to="/entreprise"
                                id="entreprise"
                                className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                                onClick={() => topFunction()}
                            >
                                Qui sommes-nous
                            </NavLink>
                            <NavLink
                                to="/competence"
                                id="competence"
                                className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                                onClick={() => topFunction()}
                            >
                                Compétences
                            </NavLink>
                            <NavLink
                                to="/realisation"
                                id="realisation"
                                className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                                onClick={() => topFunction()}
                            >
                                Nos Réalisations
                            </NavLink>
                            <NavLink
                                to="/contact"
                                id="contact"
                                className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                                onClick={() => topFunction()}
                            >
                                Devis et Contact
                            </NavLink>

                        </div>
                        <div className='mynavbar-icon' onClick={() => { setMobilenav(!mobilenav) }}>
                            <i class="fa fa-bars" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div className={`mynavbar-mobile-container ${mobilenav ? "mynavbar-mobile-container-visible" : ""}`}>
                        <div className='container mynavbar-links-mobile noPadding'>
                            <NavLink
                                to="/entreprise"
                                id="entreprise"
                                className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                                onClick={() => topFunction()}
                            >
                                Qui sommes-nous
                            </NavLink>
                            <NavLink
                                to="/competence"
                                id="competence"
                                className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                                onClick={() => topFunction()}
                            >
                                Compétences
                            </NavLink>
                            <NavLink
                                to="/realisation"
                                id="realisation"
                                className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                                onClick={() => topFunction()}
                            >
                                Nos Réalisations
                            </NavLink>
                            <NavLink
                                to="/contact"
                                id="contact"
                                className={({ isActive }) => isActive ? "my-navbar-link-active" : "my-navbar-link"}
                                onClick={() => topFunction()}
                            >
                                Devis et Contact
                            </NavLink>
                        </div>
                    </div>
                </div>

                {/* Qui sommes nous */}

                <section class="home-qsn-area" id="about" style={backgroundStyle3}>
                    <div class="homeqsnHeader noPadding container">

                        <div>
                            <div class="homeqsnTitle">
                                Notre histoire<span>.</span>
                            </div>
                            <h2 class="homeqsnDesc">Nous réalisons vos travaux de rénovation, en tous corps d&rsquo;état</h2>
                            <hr class="home-hr" ></hr>

                        </div>

                        <div class="">
                            <div class="homeqsnText">
                                Vous souhaitez moderniser votre appartement ou votre maison ?
                                L'intérieur de votre maison aurait besoin d'être réaménagé ou remis au goût du jour, vous souhaitez réagencer les espaces de vie pour créer des pièces plus grandes ou plus lumineuses ?
                                À moins que vous n’ayez tout simplement le projet d’optimiser votre lieu de travail et en repenser les différents espaces ?
                            </div>
                        </div>
                    </div>

                </section>

                {/* Counts */}

                <section class="home-counts-area " id="counts">
                    <div className='home-counts-container container noPadding' >
                        <div class="">
                            <div class="home-count-number">
                                {projets}
                            </div>
                            <div class="">
                                <i class="fa fa-briefcase home-counts-icons"></i>
                                <span class="home-counts-text">Projets Réalisés</span>
                            </div>
                        </div>
                        <div class="">
                            <div class="home-count-number">
                                {clients}
                            </div>
                            <div class="">
                                <i class="fa fa-heart home-counts-icons"></i>
                                <span class="home-counts-text">Clients Satisfaits</span>
                            </div>
                        </div>
                        <div class="">
                            <div class="home-count-number">
                                {nbpieces}
                            </div>
                            <div class="">
                                <i class="fa fa-lightbulb-o home-counts-icons"></i>
                                <span class="home-counts-text">Nombre de Pièces</span>
                            </div>
                        </div>
                    </div>
                </section>

                {/* competenceitemsgrid */}

                <section id="services">
                    <CompetenceItemsGrid />
                </section>

                {/* Nos competence */}

                <section class="home-noscompetence-area" >

                    <div class="noscompetenceHeader">

                        <div class="noscompetenceTitle">
                            Nos Compétences<span>.</span>
                        </div>
                        <h2 class="noscompetenceDesc">Nous fournissons une liste complète des meilleurs services numériques</h2>
                        <hr class="home-hr" ></hr>
                    </div>
                    <div class="noscompetenceBody container noPadding">
                        <NosCompetenceContents />
                    </div>

                </section>

                {/* Nos realisations */}

                <section class="home-nosrealisations-area" id="portfolio">
                    <div class="">
                        <div class="nosrealisationsHeader">
                            <div class="nosrealisationsTitle">
                                Nos réalisations<span>.</span>
                            </div>
                            <h2 class="nosrealisationsDesc">Le souci du détail rend notre travail excellent</h2>
                            <hr class="home-hr" ></hr>
                        </div>
                        <div className="row noMargin">

                            {chantiersList.slice(0, 6).map((data, index) => {

                                let pic = "https://decohome75.fr/api/" + data.ch_img;
                                let picurl = "https://decohome75.fr/api/";

                                return (
                                    <div className='col-6 col-sm-4 noPadding'>
                                        <div className=''>
                                            <div onClickCapture={() => {
                                                scrollToCarousel(data?.id, index, data?.ch_nom, data?.ch_type, data?.ch_desc, data?.ch_addresse, pic);
                                            }} class="nosrealisationsItems cursor-pointer">
                                                <div class="nosrealisations-items-container">
                                                    <div class={`nosrealisationsImage ${carousel && index == carouselindex3 ? "nosrealisationsImageFocus" : ""}`} alt="Work" style={{ backgroundImage: `url(${pic})` }}></div>

                                                    {/* <img class={`nosrealisationsImage ${carousel && index == carouselindex3 ? "nosrealisationsImageFocus" : ""}`} src={pic} alt="Work" /> */}

                                                    <div class="nosrealisationsText2">
                                                        <h3 style={{ color: carousel && index == carouselindex3 ? "white" : "transparent" }} class="">{data.ch_nom}</h3>
                                                        <div style={{ color: carousel && index == carouselindex3 ? "#999" : "transparent" }} class="">
                                                            {data.ch_type}
                                                        </div>
                                                    </div>
                                                </div>

                                                {carousel && index == carouselindex3 ? <div class="home-arrow-down"><i class="fa fa-caret-down" aria-hidden="true"></i></div> : <></>}
                                                <div class="nosrealisationsText" style={{ visibility: carousel && index == carouselindex3 ? "hidden" : "visible", height: carousel && index == carouselindex3 ? "0" : "auto" }}>
                                                    <h3 class="">{data.ch_nom}</h3>
                                                    <div class="">
                                                        {data.ch_type}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {(carouselmobile ? index == carouselindex2 : index == carouselindex) && carousel ?
                                            <div id='my-carousel' class={`col-12 noMargin home-realisation-carousel-container row ${getMarginTop(carouselindex3)}`}>
                                                <div className='col-lg-3 home-carousel-item1 noPadding'>
                                                    <div className='home-carousel-title'>{carouseltitle}</div>
                                                    <div className='home-carousel-type'>{carouseltype}</div>
                                                    {carouseladdresse && <div className='home-carousel-location'><i class="fa fa-map-marker home-carousel-icon"></i> {carouseladdresse}</div>}
                                                    <div className='home-carousel-description'>
                                                        {carouseldesc}
                                                    </div>
                                                </div>
                                                <div className='col-lg-9 home-carousel-item2 noPadding d-flex flex-column'>
                                                    <div className='d-flex align-items-center justify-content-between w-100'>
                                                        <div class="cursor-pointer home-carousel-arrows" onClick={() => decreaseCarousel(-1)}><i class="fa fa-angle-left "></i></div>

                                                        <div class="home-carousel-image-container">
                                                            <div class="carousel-img-smallcarousel-container">
                                                                <div style={{ position: "relative" }}>
                                                                    <img ref={imageRef} onLoad={() => {
                                                                        setTimeout(() => {
                                                                            setIsLoading(false)
                                                                        }, 2000);
                                                                    }} onClick={handleFullScreen} class="home-carousel-image cursor-pointer" src={chantiersImagesList[carouselimageindex] ? picurl + chantiersImagesList[carouselimageindex].ch_img : carouselpic} alt="Work" />
                                                                    <div class="home-carousel-status">
                                                                        {chantiersImagesList[carouselimageindex]?.img_status}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div class="cursor-pointer home-carousel-arrows" onClick={() => increaseCarousel(-1)}><i class="fa fa-angle-right"></i></div>
                                                    </div>
                                                    <div class="carousel-smallcarousel">

                                                        <div class="cursor-pointer home-carousel-arrows" onClick={() => {
                                                            decreaseSmallCarousel();
                                                        }}><i class="fa fa-angle-left"></i></div>
                                                        <div className='d-flex'>
                                                            {smallcarouselimages[0] && <div class={`cursor-pointer  ${selected == smallcarouselimages[0].ch_img ? "smallcarousel-selected" : "smallcarousel-unselected"}`} onClick={() => {
                                                                getpicIndex(smallcarouselimages[0].ch_img);
                                                            }} style={{ backgroundImage: `url(${picurl + smallcarouselimages[0].ch_img})` }}></div>
                                                            }
                                                            {smallcarouselimages[1] && <div class={`cursor-pointer  ${selected == smallcarouselimages[1].ch_img ? "smallcarousel-selected" : "smallcarousel-unselected"}`} onClick={() => {
                                                                getpicIndex(smallcarouselimages[1].ch_img);
                                                            }} style={{ backgroundImage: `url(${picurl + smallcarouselimages[1].ch_img})` }}></div>}
                                                            {smallcarouselimages[2] && <div class={`cursor-pointer  ${selected == smallcarouselimages[2].ch_img ? "smallcarousel-selected" : "smallcarousel-unselected"}`} onClick={() => {
                                                                getpicIndex(smallcarouselimages[2].ch_img);
                                                            }} style={{ backgroundImage: `url(${picurl + smallcarouselimages[2].ch_img})` }}></div>}
                                                            {smallcarouselimages[3] && <div class={`cursor-pointer  ${selected == smallcarouselimages[3].ch_img ? "smallcarousel-selected" : "smallcarousel-unselected"}`} onClick={() => {
                                                                getpicIndex(smallcarouselimages[3].ch_img);
                                                            }} style={{ backgroundImage: `url(${picurl + smallcarouselimages[3].ch_img})` }}></div>}
                                                        </div>
                                                        <div class="cursor-pointer home-carousel-arrows" onClick={() => {
                                                            increaseSmallCarousel();
                                                        }}><i class="fa fa-angle-right"></i></div>

                                                    </div>
                                                </div>
                                                <div onClick={() => {
                                                    setCarousel(false);
                                                    setCarouselIndex(-1)
                                                    setCarouselIndex2(-1)
                                                    setCarouselIndex3(-1)
                                                    setCarouselTitle("");
                                                    setCarouselDesc("");
                                                    setCarouselAddresse("");
                                                    setCarouselType("");
                                                    setCarouselPic("");
                                                    setSelected("")
                                                }} className='home-carousel-item3 cursor-pointer'><i class="fa fa-times"></i></div>
                                            </div> : <></>}
                                    </div>
                                )

                            })
                            }
                        </div>

                        <div class="decouvrirplusContainer" onClickCapture={() => { global.globalType = 'all'; navigation('/realisation') }}>
                            <div class="decouvrirplusButton cursor-pointer">DECOUVRIR PLUS</div>
                        </div>



                    </div>
                </section>

                {/* Vous aimez notre travail? */}

                <section class="home-vant-bg">
                    <div class="home-vant-area container">
                        <div class="home-vant-left">
                            <div class="home-vant-title">Vous aimez notre travail?</div>
                            <div class="home-vant-desc">
                                Nous sommes toujours ouverts à des projets intéressants.
                            </div>
                        </div>
                        <div class="home-white-button" onClick={() => { navigation("/contact") }}>
                            <div class="home-dollar"><i style={{ fontSize: "50px", }} class="fa fa-usd"></i></div>
                            <div class="home-white-button-text">
                                Obtenir un devis
                            </div>
                        </div>
                    </div>
                </section>

                <FooterMainComponent />

                <FooterComponent />


            </div>


        </div>
    );
}


export default Index;
